<div>
  <div class="signup-requests-headers">
    <div class="page-title">Organization Signup Requests</div>
    @if (applications.length > 0) {
      <div class="page-size">
        <app-page-size
          [pageSize]="pageSize"
          [selectId]="'signup-requests-list'"
          (pageSizeChanged)="onPageSizeChange($event)"
        ></app-page-size>
      </div>
    }
  </div>

  <app-connection-signup-dashboard></app-connection-signup-dashboard>

  <div class="top-section">
    <div class="filter-search-section">
      <div class="page-filter">
        <app-filter
          [filterBy]="filterBy"
          [filterByOptions]="filterByOptions"
          (filterByChanged)="onFilterByChange($event)"
        ></app-filter>
      </div>
      <div class="search-section-wrapper">
        <div class="search-section">
          <app-svg-icon [iconName]="'search.svg'" class="svg"></app-svg-icon>
          <input
            type="text"
            placeholder="Search ..."
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchQueryChange($event)"
          />
        </div>
      </div>
    </div>
  </div>

  <app-table
    [columns]="tableColumns"
    [data]="applications"
    [loading]="loading"
    [noResultsMessage]="'No signup requests found.'"
    [skeletonRows]="3"
  >
    <ng-template let-application>
      <tr>
        <td>
          <div class="org-section">
            <div class="org-name">
              {{ application.organization_name }}
            </div>
            <!-- <div class="submitted-date">
                Submitted on {{ application.created_on_utc | date: "medium" }}
              </div> -->
          </div>
        </td>
        <td>{{ getOrgTypeLabel(application.org_type) }}</td>
        <td>{{ application.contact_email }}</td>
        <td>
          <a [href]="ensureHttpProtocol(application.website)" target="_blank">
            {{ application.website }}
          </a>
        </td>
        <td>
          <span class="status-badge status-{{ getStatusClass(application) }}">
            {{ getStatusLabel(application) }}
          </span>
        </td>
        <td style="color: #6b7280; font-size: 0.875rem">
          {{ application.created_on_utc | date: "medium" }}
        </td>
        <td>
          <div class="action-icons">
            <a
              href="javascript:void(0)"
              (click)="viewApplicationDetails(application)"
            >
              View
            </a>
          </div>
        </td>
      </tr>
    </ng-template>
  </app-table>
</div>

@if (applications.length > 0) {
  <app-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="totalApplications"
    (pageChanged)="onPageChange($event)"
  ></app-pagination>
}

@if (showDetailsModal && selectedApplication) {
  <app-secondary-popup
    [title]="selectedApplication.organization_name"
    [isActionButtonsAvailable]="
      selectedApplication.status === getConnectionSelfSignupStatus().Pending
    "
    [primaryActionName]="'Approve'"
    [secondaryActionName]="'Reject'"
    (popupClosed)="onDetailsModalClosed(false)"
    (primaryAction)="onApproveAction()"
    (secondaryAction)="onRejectAction()"
  >
    <app-manage-connection-signup
      [applicationId]="selectedApplication.id"
      (closeModal)="onDetailsModalClosed(true)"
      (approveClicked)="onApproveAction()"
      (rejectClicked)="onRejectAction()"
    ></app-manage-connection-signup>
  </app-secondary-popup>
}
